import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { useFilial } from '@/lib/filial'

/** Logo (data URL) da filial atual selecionada, ou null (consolidado / sem logo). */
export function useFilialLogo(): string | null {
  const filialAtual = useFilial(s => s.filialAtual)
  const modoConsolidado = useFilial(s => s.modoConsolidado)
  const fid = !modoConsolidado && filialAtual?.id ? filialAtual.id : null
  const { data } = useQuery<any>({
    queryKey: ['filial-logo', fid],
    queryFn: async () => (await api.get(`/filiais/${fid}/logo`)).data,
    enabled: !!fid,
    staleTime: 5 * 60 * 1000,
  })
  return data?.logo_data || null
}
